
import {dataSource} from './dataSource'
import {uploadPhoto} from './networkRequests'
import {openAsset} from './openAsset'
import {OA_MARK} from '../shared/Data/typeDirs'
// const PHOTOS = 'photos'





class OAPhotoManager {
  constructor(){
    this.queue = [] // [{_id, type_dir}]
    this.displayMessage = function(){}
    this.numErrors = 0
    this.executing = false
  }

  async displayStatus(){

    this.displayMessage(`Queue contains ${this.queue.length} photos`)
    return this.queue
  }

  setDisplayProgress(fn){
    this.displayProgress = fn
  }

  setDisplayMessage(fn){
    this.displayMessage = fn
  }

  async addToQueue(queueItem){
    this.queue.push(queueItem)
  }

  async executeQueue(user, progressCallback = ()=>{}, endCallback= ()=>{}){
    if(this.executing){
      this.displayMessage(`Already executing upload`)
      return
    }

    this.executing = true
    let ct = 1

    for (let id of this.queue){
      this.displayMessage(`Executing Queue: ${ct} / ${this.queue.length}`)
      console.log('getting id', id, this.queue)
      let mark = await dataSource('remDb')[OA_MARK].getTyped({_id:id})
      await mark.putToMetastoryFromOpenAsset(openAsset, dataSource, uploadPhoto, user.token, this.displayMessage)
      await progressCallback(ct)
      ct++
    }
    this.queue = []
    this.executing = false
    this.displayMessage('OA Photos Moved to Metastory successfully')
    endCallback()
  }

}

export {OAPhotoManager}
